import { ReservationTimeState } from '@mews-commander/data-access';

export const balanceLoadTimeState = [
    ReservationTimeState.ToBeCheckedIn,
    ReservationTimeState.CheckInMissed,
    ReservationTimeState.CheckedIn,
    ReservationTimeState.ToBeCheckedOut,
    ReservationTimeState.CheckOutMissed,
];
